import {useInfiniteQuery} from "@tanstack/react-query";
import {GtaRatesApiClient} from "@/Service/Api/V1/ApiClients/GtaRatesApiClient";
import {GetGtaRateListRequest} from "@/Stub/V1";
import {QueryKeys} from "@/Service/Api/V1/QueryKeys/QueryKeys";

export type UseGetGtaRatesInfiniteParams = {
    requestParams?: GetGtaRateListRequest
    enabled?: boolean
};

export const useGetGtaRatesInfinite = ({
                                           enabled = true,
                                           requestParams = {}
                                       }: UseGetGtaRatesInfiniteParams) => useInfiniteQuery({
    ...QueryKeys.gtaRates.list(requestParams),
    queryFn: async ({pageParam = 1}) => {
        return await GtaRatesApiClient.getGtaRateList({...requestParams, page: pageParam});
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages, lastPageParam) => {
        if (lastPageParam === lastPage.meta.last_page) {
            return undefined;
        }
        return ++lastPageParam;
    },
    enabled,
});
